import {UpdateService} from "./services/update.service";
import {EventService} from "./services/event.service";
import {Version} from "./classes/version";
import {Config} from "./classes/config";
import {DataService} from "./services/data.service";
import {Component, ViewChild, ViewChildren, QueryList} from "@angular/core";
import {
  Platform,
  IonRouterOutlet,
  ModalController,
  MenuController,
  ToastController,
  IonMenu,
} from "@ionic/angular";
import {Router} from "@angular/router";
import {Shop} from "./classes/login";
import {getConfig} from "./classes/getConfig/getConfig";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
})
export class AppComponent {
  @ViewChild(IonMenu, {read: IonMenu}) menu: IonMenu;
  @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;

  public imageUrl = "";
  public kontakt = "";
  public config: Config;
  public version: Version;

  public showInstallMessage = false;

  constructor(
    private platform: Platform,
    public router: Router,
    public data: DataService,
    public modalCtrl: ModalController,
    public menuCtrl: MenuController,
    public toastCtrl: ToastController,
    public eventService: EventService,
    updateService: UpdateService,
  ) {
    // Detects if device is on iOS
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    };

    // Detects if device is in standalone mode
    const isInStandaloneMode = () =>
      "standalone" in window.navigator && (<any>window.navigator).standalone;

    // Checks if should display install popup notification:
    if (isIos() && !isInStandaloneMode()) {
      this.showInstallMessage = true;
    }

    this.initializeApp();
    this.config = getConfig();
    this.version = new Version();
    eventService.imageUrlChanged$.subscribe((url) => {
      this.imageUrl = url;
    });
    eventService.shopStatusChanged$.subscribe((shop: Shop) => {
      this.kontakt = shop.kontakt;
    });

    // Check if updater is enabled
    updateService.checkAvailability();
  }

  async installIOs() {
    const toast = await this.toastCtrl.create({
      message:
        'Um die Anwendung auf dem iPhone zu installieren: ⍐ klicken und dann "Zum Home-Bildschirm" klicken',
      buttons: [
        {
          text: "Ok",
          role: "cancel",
        },
      ],
      position: "bottom",
    });
    toast.present();
  }

  isEdge() {
    const ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    const msie = ua.indexOf("MSIE ");
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
    }

    const trident = ua.indexOf("Trident/");
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf("rv:");
      return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
    }

    const edge = ua.indexOf("Edge/");
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
    }

    // other browser
    return false;
  }

  install() {
    if (this.data.installPrompt !== undefined && this.data.installPrompt !== null) {
      // Show the prompt
      this.data.installPrompt.prompt();
      // Wait for the user to respond to the prompt
      this.data.installPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the A2HS prompt");
        } else {
          console.log("User dismissed the A2HS prompt");
        }
        // We no longer need the prompt.  Clear it up.
        this.data.installPrompt = null;
      });
    }
  }

  initializeApp() {
    console.log("initializeApp...");
    window.addEventListener("beforeinstallprompt", (e) => {
      console.log("beforeinstallprompt Event fired");
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.data.installPrompt = e;
      this.showInstallMessage = false;
    });

    this.platform.ready().then(() => {});
  }

  followLink(url: string) {
    window.open(url, "_blank");
  }

  logout() {
    this.eventService.imageUrlChanged$.emit(null);
    this.menu.close();
    this.data.logout();
    this.router.navigateByUrl("/login");
  }

  resetImageUrl = (): void => {
    this.imageUrl = "";
  };

  changeAgbLink = (agbUrl: string): void => {
    document.getElementById("agbLink").setAttribute("href", "http://www.google.de");
  };
}
